// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3BWPF","buttons":"PendingPaymentAlert_buttons__3NT3x"};